export enum MachineType {
  ES2000 = 'ES2000',
  EHT = 'EHT',
  ELT = 'ELT',
  EUHT = 'EUHT',
  EULT = 'EULT',
  XLHT = 'XLHT',
  EH500S = 'EH500S',
  XLRW = 'XLRW',
}
